export interface Tutorial {
  slug: string;
  title: string;
  poster: string;
  src: string;
  available: boolean;
  durationLabel?: string;
}

// Assets live in public/tutorials/<slug>.{mp4,jpg}. Flip `available` to true
// once the recording lands. Titles map to the checklist journey.
export const tutorials: Tutorial[] = [
  { slug: "submit-a-claim", title: "How to submit a claim", poster: "/tutorials/submit-a-claim.jpg", src: "/tutorials/submit-a-claim.mp4", available: false },
  { slug: "add-banking-details", title: "Adding your banking details", poster: "/tutorials/add-banking-details.jpg", src: "/tutorials/add-banking-details.mp4", available: false },
  { slug: "renew-a-card", title: "Renewing your NIB card", poster: "/tutorials/renew-a-card.jpg", src: "/tutorials/renew-a-card.mp4", available: false },
];

export function visibleTutorials(list: Tutorial[] = tutorials): Tutorial[] {
  return list.filter((t) => t.available);
}
